import * as React from "react";
import {
    Renewal,
    PREMIUM_TYPE_MONTHLY,
    PREMIUM_TYPE_ANNUAL,
    productHelper,
    Policy,
    RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL, ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL,
} from "@falcon/services";
import {formatDateTime} from "../../CommonFunctions";
import {Link} from "react-router-dom";

interface IAutoRenewalInviteBannerProps {
    renewalProposal: Renewal;
    vehicle?: any;
    address?: any;
    policy: Policy;
    interaction: any;
}

interface IAutoRenewalInviteBannerState {
    displayInfoMessage: boolean;
}

export class GracePeriodBanner extends React.Component<IAutoRenewalInviteBannerProps, IAutoRenewalInviteBannerState> {

    constructor(props: IAutoRenewalInviteBannerProps) {
        super(props);

        this.state = {
            displayInfoMessage: false
        };
    }

    public render() {
        const premiumType: string = this.props.renewalProposal.factors.premiumType;
        const isHome: boolean = productHelper.isHome(this.props.interaction);
        const productWording = isHome ? `home policy for ${this.props.address.addressLine1}, ... ${this.props.address.postalCode} ended on ${formatDateTime(this.props.policy.endDate)}.` :
            `car policy for ${this.props.vehicle?.make} ${this.props.vehicle?.model} ended on ${formatDateTime(this.props.policy.endDate)}.`;
        return (
            <>
                {<div className="banner banner-info">
                    <div className="banner-text">
                        <p>
                            You are no longer covered. Your <strong>{productWording}</strong> You can still renew your policy up to {isHome ? "2" : "5"} days after expiry date.
                        </p>
                        <div className="pt-20">
                            Set up your renewal for{" "}
                                {premiumType === PREMIUM_TYPE_ANNUAL &&
                                <>
                                    £{this.props.renewalProposal.factors.annualPremium} / year.
                                </>
                                }
                                {premiumType === PREMIUM_TYPE_MONTHLY &&
                                <>
                                    £{this.props.renewalProposal.paymentDetails.instalmentPlan.monthlyPayment} / month (£{this.props.renewalProposal.paymentDetails.instalmentPlan.totalAmount} total).
                                </>
                                }
                        </div>
                        <div className="row mt-2">
                            <div className="col-12">
                                <div className="mt-2">
                                    <Link className="btn btn-primary m-auto text-decoration-none" to={isHome ? ANNUAL_HOME_RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.props.renewalProposal._id : RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL + this.props.renewalProposal._id}>Renew your policy now</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/banners/GracePeriodBanner.tsx